import { ArrowRight, Chrome } from "lucide-react";
import { EXTENSION_URL, trackEvent } from "@/lib/analytics";

interface InContentCTAProps {
  placement?: string;
}

/**
 * In-content CTA block intended to be injected mid-article on blog posts.
 * Tracks `blog_to_extension` to GA4 so we can attribute extension installs to content.
 */
const InContentCTA: React.FC<InContentCTAProps> = ({ placement = "blog_mid" }) => {
  return (
    <aside
      className="my-10 rounded-2xl border border-[#0066FF]/20 bg-gradient-to-br from-[#0066FF]/5 to-blue-50 p-6 sm:p-8 not-prose"
      aria-label="Try DeepSeek in your browser"
    >
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-5">
        <div className="flex-1">
          <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-1">
            Use DeepSeek on every website
          </h3>
          <p className="text-sm sm:text-base text-gray-600">
            Add the free AI Sidebar — chat with DeepSeek R1 & V3 next to any page, no copy-pasting.
          </p>
        </div>
        <a
          href={EXTENSION_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() =>
            trackEvent("blog_to_extension", { placement, source: "in_content_cta" })
          }
          className="inline-flex items-center justify-center px-6 py-3 text-sm sm:text-base font-medium rounded-full text-white bg-[#0066FF] hover:bg-[#0066FF]/90 transition-all shadow-[0_4px_14px_0_rgba(0,102,255,0.39)] hover:shadow-[0_6px_20px_rgba(0,102,255,0.23)] hover:-translate-y-[1px] whitespace-nowrap"
        >
          <Chrome className="mr-2 h-5 w-5" />
          Add to Chrome — Free
          <ArrowRight className="ml-2 h-4 w-4" />
        </a>
      </div>
    </aside>
  );
};

export default InContentCTA;
